import React, {lazy} from 'react';
import {Route} from 'react-router-dom';


import * as registrationConstants from '../modules/Registration/registrationConstants';

import RootRoutes from './RootRoutes';

const RegistrationPages = lazy(() => import('../modules/Registration/pages'));


const PublicRoot = function PublicRoot() {

    return (
        <RootRoutes>
            <Route
                element={<RegistrationPages/>}
                path={`${registrationConstants.NAV_REGISTRATION_BASE}/*`}
            />
        </RootRoutes>
    );
};


export default PublicRoot;
